class scrollHelper {
    constructor() {
        this.init();
        this.initPricingPageClick();
        this.bindScrollHandler();
        this.checkForHashToScrollTo();
    }

    init() {

    }

    initPricingPageClick() {
        // $('.ont-module.pricing .features a, .ont-module.plans a').on('click', function (e) {
        //     e.preventDefault();
        //     var href = $(this).attr('href');
        //     if (/^#/.test(href)) {
        //         var answer = $(href);
        //         answer.collapse('show');
        //         $('html, body').animate({
        //             scrollTop: answer.offset().top - 225
        //         }, 1000);
        //     }
        // });
    }

    bindScrollHandler() {
        var scrollLinks = Array.from(document.querySelectorAll('[data-scroll-to]'));
        scrollLinks.forEach((link, i) => {
            $(link).on('click', function (e) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $($(this).attr('href')).offset().top - 140
                }, 1000);
            });
        });
    }

    checkForHashToScrollTo() {

        window.onload = (event) => {
            var hash = location.hash.replace('#', '');

            if (hash != '' && $('#' + hash).top) {
                $('html, body').animate({
                    scrollTop: $('#' + hash).offset().top - 140
                }, 100);
            } else {

                var answer = $('#answer-' + hash);
                if (answer.length) {
                    answer.collapse('show');
                    $('html, body').animate({
                        scrollTop: answer.offset().top - 225
                    }, 100);
                }
            }
        }
    }
}

window.app.add('scroll', new scrollHelper());